import { useDictionary } from "@adamlip/okeoke.client"
import CurrentOpenHours from "./CurrentOpenHours"
import moment from "moment"
import { Card, CardBody, CardFooter, Divider, Image } from "@nextui-org/react"
import { useEffect, useState } from "react"

export default function LocationCard({ location, navigateToOrder }) {
  const { getValue } = useDictionary()

  const [isClosed, setIsClosed] = useState(false)

  useEffect(() => {
    if (location?.attributes?.openHours?.[moment().isoWeekday()]?.closed) {
      setIsClosed(true)
    } else {
      setIsClosed()
    }
  }, [location])
  return (
    <Card
      key={location.uuid}
      className={`w-[45%] max-w-[300px] shrink-0 mx-2 my-3 relative bg-[var(--main-secondary-bg-color)]`}
    >
      {!isClosed && (
        <>
          <div
            className={`absolute top-0 w-full h-6 z-10 text-center`}
            style={{
              background:
                location?.extendedPrepTime?.reason == null
                  ? "linear-gradient(180deg, rgba(23,201,100,1) 0%, rgba(255,255,255,0) 100%)"
                  : location?.extendedPrepTime?.reason === 1
                    ? "linear-gradient(180deg, rgba(245,165,36,1) 0%, rgba(255,255,255,0) 100%)"
                    : location?.extendedPrepTime?.reason === 2
                      ? "linear-gradient(180deg, rgba(243,18,96,1) 0%, rgba(255,255,255,0) 100%)"
                      : "linear-gradient(180deg, rgba(23,201,100,1) 0%, rgba(255,255,255,0) 100%)",
            }}
          ></div>
          <div
            className={`absolute top-0 left-[50%] translate-x-[-50%] px-2 w-f h-6 z-10 bg-white text-black text-center`}
            style={{
              borderBottomLeftRadius: "8px",
              borderBottomRightRadius: "8px",
            }}
          >
            {location?.extendedPrepTime?.reason == null &&
              getValue("app_v2_location_prep_normal")}
            {location?.extendedPrepTime?.reason === 1 &&
              getValue("app_v2_location_prep_heavy")}
            {location?.extendedPrepTime?.reason === 2 &&
              getValue("app_v2_location_prep_extreme")}
          </div>
        </>
      )}
      <div className="h-[150px] md:h-[200px]">
        <div className="aspect-ratio">
          <Image
            removeWrapper
            alt="Card background"
            className="z-0 w-full h-full object-cover rounded-none"
            src={
              location?.attributes?.locationImage
                ? location?.attributes?.locationImage
                : "https://cdn.okeoke.io/globalAsset/backgrounds/cafe"
            }
          />
        </div>
      </div>
      <CardBody className="min-h-[72px]">
        <div className="flex flex-col" id={location.uuid}>
          <div className="text-md font-bold truncate">{location.name}</div>
          <CurrentOpenHours location={location} />
        </div>
      </CardBody>
      <Divider />
      <CardFooter className="justify-center">
        <p
          className="text-sm opacity-50 cursor-pointer"
          onClick={() => navigateToOrder()}
        >
          {getValue("app_v2_go_to_order")}
        </p>
      </CardFooter>
    </Card>
  )
}
